<!-- Mobile backdrop -->
@if (isSidebarOpen) {
  <div
    class="md:hidden fixed inset-0 z-30 bg-black/50"
    (click)="closeSidebar()"
    (keydown.enter)="closeSidebar()"
    (keydown.space)="closeSidebar()"
    tabindex="0"></div>
}

<aside
  class="fixed top-0 left-0 z-40 w-64 h-screen pt-16 transition-transform -translate-x-full bg-white border-r border-gray-200 md:translate-x-0 flex flex-col"
  aria-label="Sidenav"
  id="drawer-navigation"
  [ngClass]="{
    '-translate-x-full': !isSidebarOpen,
    'translate-x-0': isSidebarOpen,
  }">
  <div class="flex-1 overflow-y-auto pt-3 px-3 bg-white">
    <a
      href="#"
      class="sm:hidden flex justify-between items-center p-2 py-4 w-full border-b border-gray-100 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-200"
      type="button">
      <span class="sr-only">Open user menu</span>
      <div class="flex items-center">
        @if (avatarUrl()) {
          <img
            [src]="avatarUrl()!"
            class="mr-3 w-8 h-8 rounded-full object-cover"
            alt="Your profile photo" />
        } @else {
          <span
            class="mr-3 w-8 h-8 rounded-full bg-primary-100 text-primary-700 text-sm font-semibold flex items-center justify-center">
            {{ me()?.givenName?.[0] }}{{ me()?.familyName?.[0] }}
          </span>
        }
        <div class="text-left">
          <div class="font-semibold leading-none text-gray-900 mb-0.5">
            {{ fullName }}
          </div>
          <div class="text-sm text-gray-500">{{ email }}</div>
        </div>
      </div>
    </a>

    <div class="w-full grid gap-y-2">
      <button
        type="button"
        (click)="handleInvitePatient()"
        class="leading-normal sm:hidden flex items-center justify-center px-5 py-2.5 text-xs font-medium text-primary-700 border border-primary-700 rounded-lg">
        <mat-icon class="h-4 w-4 mr-2" svgIcon="plus"></mat-icon>
        Invite patient
      </button>
      <button
        type="button"
        (click)="openNewAppointmentDialog()"
        class="leading-normal sm:hidden flex items-center justify-center px-5 py-2.5 text-xs font-bold text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 focus:outline-none cursor-pointer">
        <mat-icon class="h-4 w-4 mr-2" svgIcon="plus"></mat-icon>
        New Appointment
      </button>
    </div>
    <div class="flex gap-5 flex-col">
      <ul
        class="flex flex-col gap-2 py-4 sm:py-0 border-t border-gray-100 sm:border-t-0">
        @for (navItem of navItems(); track navItem.label) {
          @if (navItem.children && navItem.children.length > 0) {
            <li class="m-0!">
              <a
                type="button"
                class="flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100"
                [routerLink]="navItem.route"
                routerLinkActive="bg-gray-100"
                (click)="closeSidebar()"
                [routerLinkActiveOptions]="{ exact: false }"
                (click)="navItem.collapsed = !navItem.collapsed">
                <svg
                  aria-hidden="true"
                  class="shrink-0 w-6 h-6 text-gray-400 transition duration-75"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                    clip-rule="evenodd"></path>
                </svg>
                <span class="flex-1 ml-3 text-left whitespace-nowrap">{{
                  navItem.label
                }}</span>
                <svg
                  aria-hidden="true"
                  class="w-6 h-6"
                  [class.rotate-180]="!navItem.collapsed"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"></path>
                </svg>
              </a>

              @if (!navItem.collapsed) {
                <ul id="dropdown-pages" class="py-2 space-y-2">
                  @for (subItem of navItem.children; track subItem.label) {
                    <li>
                      <a
                        [routerLink]="navItem.route + '/' + subItem.route"
                        routerLinkActive="bg-gray-100"
                        (click)="closeSidebar()"
                        class="flex items-center p-2 pl-11 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100"
                        >{{ subItem.label }}</a
                      >
                    </li>
                  }
                </ul>
              }
            </li>
          }
          <!-- single nav item -->
          @else {
            <li class="m-0!">
              <a
                #rla="routerLinkActive"
                [routerLink]="navItem.route"
                routerLinkActive
                (click)="closeSidebar()"
                class="flex items-center p-2 text-base font-medium rounded-lg hover:bg-gray-100 group"
                [style.background-color]="rla.isActive ? '#EAF2FF' : ''"
                [style.color]="rla.isActive ? '#2563EB' : ''">
                @let icon = navItem?.icon;
                @if (icon) {
                  <mat-icon
                    [svgIcon]="icon"
                    class="w-6 h-6"
                    [style.color]="
                      rla.isActive ? '#2563EB' : '#9CA3AF'
                    "></mat-icon>
                }

                <span class="flex-1 ml-3 whitespace-nowrap">{{
                  navItem.label
                }}</span>
                @if (navItem.route === 'chats' && totalUnreadCount() > 0) {
                  <span
                    class="ml-auto flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-blue-600 text-white text-[10px] font-medium leading-none">
                    {{ totalUnreadCount() }}
                  </span>
                }
                @if (navItem.route === 'calls' && voicemailUnreadCount() > 0) {
                  <span
                    aria-label="Unread voicemails"
                    class="ml-auto flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-blue-600 text-white text-[10px] font-medium leading-none"
                    >{{ voicemailUnreadCount() }}</span
                  >
                }
              </a>
            </li>
          }
        }
      </ul>

      @if (careToolsItems().length > 0) {
        <div class="px-2 flex flex-col gap-4">
          <div
            class="leading-none text-sm font-medium text-gray-500 uppercase tracking-wide">
            Care tools
          </div>

          <ul class="flex flex-col gap-2">
            @for (item of careToolsItems(); track item.label) {
              <li>
                @if (item.route) {
                  <a
                    #rla="routerLinkActive"
                    [routerLink]="item.route"
                    routerLinkActive
                    (click)="closeSidebar()"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="flex items-center p-2 text-base font-medium rounded-lg hover:bg-gray-100 group"
                    [style.background-color]="rla.isActive ? '#EAF2FF' : ''"
                    [style.color]="rla.isActive ? '#2563EB' : ''">
                    @if (item?.icon) {
                      <mat-icon
                        [svgIcon]="item.icon!"
                        class="w-6 h-6"
                        [style.color]="
                          rla.isActive ? '#2563EB' : '#9CA3AF'
                        "></mat-icon>
                    }
                    <span class="flex-1 ml-3 whitespace-nowrap">{{
                      item.label
                    }}</span>
                  </a>
                }
              </li>
            }
          </ul>
        </div>
      }

      @if (growthItems().length > 0) {
        <div class="px-2 flex flex-col gap-4">
          <div
            class="leading-none text-sm font-medium text-gray-500 uppercase tracking-wide">
            Growth
          </div>

          <ul class="flex flex-col gap-2">
            @for (item of growthItems(); track item.label) {
              <li>
                <a
                  #rla="routerLinkActive"
                  [routerLink]="item.route"
                  routerLinkActive
                  (click)="closeSidebar()"
                  [routerLinkActiveOptions]="{ exact: false }"
                  class="flex items-center p-2 text-base font-medium rounded-lg hover:bg-gray-100 group"
                  [style.background-color]="rla.isActive ? '#EAF2FF' : ''"
                  [style.color]="rla.isActive ? '#2563EB' : ''">
                  @if (item?.icon) {
                    <mat-icon
                      [svgIcon]="item.icon!"
                      class="w-6 h-6"
                      [style.color]="
                        rla.isActive ? '#2563EB' : '#9CA3AF'
                      "></mat-icon>
                  }
                  <span class="flex-1 ml-3 whitespace-nowrap">{{
                    item.label
                  }}</span>
                </a>
              </li>
            }
          </ul>
        </div>
      }

      <div class="px-2 flex flex-col gap-4">
        <div
          class="leading-none text-sm font-medium text-gray-500 uppercase tracking-wide">
          Provider setup
        </div>

        <ul class="flex flex-col gap-2">
          @for (item of providerItems(); track item.label) {
            <li>
              <a
                #rla="routerLinkActive"
                [routerLink]="item.route"
                routerLinkActive
                (click)="closeSidebar()"
                [routerLinkActiveOptions]="{ exact: false }"
                class="flex items-center p-2 text-base font-medium rounded-lg hover:bg-gray-100 group"
                [style.background-color]="rla.isActive ? '#EAF2FF' : ''"
                [style.color]="rla.isActive ? '#2563EB' : ''">
                @if (item?.icon) {
                  <mat-icon
                    [svgIcon]="item.icon!"
                    class="w-6 h-6"
                    [style.color]="
                      rla.isActive ? '#2563EB' : '#9CA3AF'
                    "></mat-icon>
                }
                <span class="flex-1 ml-3 whitespace-nowrap">{{
                  item.label
                }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <div class="px-3 mt-5 w-full bg-white z-20">
    <ul class="sm:hidden block py-4 space-y-2">
      <li>
        <a
          href="#"
          class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg hover:bg-gray-100 group">
          <svg
            class="shrink-0 w-6 h-6 text-gray-400 transition duration-75 group-hover:text-gray-900"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"></path>
          </svg>
          <span class="flex-1 ml-3 whitespace-nowrap">Settings</span>
        </a>
      </li>
      <li>
        <button
          class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg hover:bg-gray-100 group"
          (click)="logout()">
          <svg
            class="shrink-0 w-6 h-6 text-gray-400 transition duration-75 group-hover:text-gray-900"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"></path>
          </svg>
          <span class="flex-1 ml-3 whitespace-nowrap">Sign out</span>
        </button>
      </li>
    </ul>
    <ul class="pb-3 pl-2 space-y-2">
      <li>
        <button
          class="flex items-center text-sm text-gray-500 hover:text-gray-900 group"
          (click)="openHelpCenterDialog()">
          <mat-icon
            svgIcon="support"
            class="shrink-0 w-3.5! h-3.5! text-gray-500 transition duration-75 group-hover:text-gray-900!]" />

          <span class="ml-2">Technical support</span>
        </button>
      </li>
    </ul>
  </div>
</aside>
